<div class="flight">
    @if (displayPartLabel) {
        <mat-expansion-panel [expanded]="panelOpenState" [togglePosition]="'before'" class="mat-elevation-z0">
            <mat-expansion-panel-header>
                <div class="mat-body-1 m-0 title">
                    @if (!displayOnlyAwb) {
                        PART {{ flightIdentifier[index] }}: {{ flightNumber }}
                    }
                    @if (displayOnlyAwb) {
                        {{ flightNumber }}
                    }
                </div>
            </mat-expansion-panel-header>
            <ng-container *ngTemplateOutlet="paymentsDetailsSection"></ng-container>
        </mat-expansion-panel>
    }
    @if (!displayPartLabel) {
        <ng-container *ngTemplateOutlet="paymentsDetailsSection"></ng-container>
    }
    <ng-template #paymentsDetailsSection>
        @for (paymentRequest of allPayments; let paymentsCartIndex = $index; track paymentsCartIndex) {
            <div class="flight-information" [ngClass]="{ 'extra-item': paymentRequest.isAccessorial }">
                <app-payment-details-rates [payment]="paymentRequest" />
                <div>
                    <app-payment-actions-button [paymentRequest]="paymentRequest" />
                </div>
            </div>
        }
    </ng-template>
</div>
